var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 12.5C22.75 18.1539 18.1539 22.75 12.5 22.75C6.84614 22.75 2.25 18.1539 2.25 12.5C2.25 6.84614 6.84614 2.25 12.5 2.25C18.1539 2.25 22.75 6.84614 22.75 12.5ZM2.75 12.5C2.75 17.8761 7.12386 22.25 12.5 22.25C17.8761 22.25 22.25 17.8761 22.25 12.5C22.25 7.12386 17.8761 2.75 12.5 2.75C7.12386 2.75 2.75 7.12386 2.75 12.5Z",
    fill: "#454551",
    stroke: "#454551"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 12.5C16.25 12.6339 16.1339 12.75 16 12.75H10C9.86614 12.75 9.75 12.6339 9.75 12.5C9.75 12.3661 9.86614 12.25 10 12.25H16C16.1339 12.25 16.25 12.3661 16.25 12.5Z",
    fill: "#454551",
    stroke: "#454551"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7499 9.50006C12.7499 9.69006 12.6799 9.88006 12.5299 10.0301L10.0599 12.5001L12.5299 14.9701C12.8199 15.2601 12.8199 15.7401 12.5299 16.0301C12.2399 16.3201 11.7599 16.3201 11.4699 16.0301L8.46994 13.0301C8.17994 12.7401 8.17994 12.2601 8.46994 11.9701L11.4699 8.97006C11.7599 8.68006 12.2399 8.68006 12.5299 8.97006C12.6799 9.12006 12.7499 9.31006 12.7499 9.50006Z",
    fill: "#454551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.75caef404cc55fe9607d05dc0519d01f.svg";
export { ForwardRef as ReactComponent };